import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon, BatteryWarningIcon, TrendingDownIcon, MapIcon } from 'lucide-react';
export function Problem() {
  const pains = [{
    icon: <BatteryWarningIcon className="w-8 h-8 text-red-500" data-id="element-86" />,
    title: 'Clases que te consumen tiempo',
    desc: 'Terminás pasando horas pensando qué entrenamiento dar, qué ejercicios usar, cómo adaptar el terreno y cómo organizar el grupo. El tiempo que podrías usar para descansar, estar con tu familia o relajarte, se va preparando clases.'
  }, {
    icon: <MapIcon className="w-8 h-8 text-orange-500" data-id="element-87" />,
    title: 'No es lo mismo calle que montaña',
    desc: 'En trail running no alcanza con copiar una clase de running tradicional. Hay subidas, bajadas, terrenos irregulares, barro, piedras, desnivel, técnica, seguridad y adaptación constante.'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-yellow-500" data-id="element-88" />,
    title: 'El riesgo de improvisar',
    desc: 'Si la clase no está bien estructurada, el grupo se desordena, aparecen molestias, los alumnos se frustran y vos quedás con la sensación de que podrías haber dado una experiencia mucho más profesional.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-brand-volt" data-id="element-89" />,
    title: 'Te cuesta diferenciarte',
    desc: 'Muchos profes ofrecen running. Pero pocos tienen una propuesta clara de trail running, con planificación, técnica, seguridad, entrenamientos específicos y una experiencia que justifique cobrar más.'
  }];
  return <section className="py-24 px-4 bg-brand-surface border-y border-brand-muted/10" data-id="element-90">
      <div className="max-w-6xl mx-auto" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="max-w-3xl mb-16" data-id="element-93">
            <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-94">
              LA REALIDAD DEL PROFE DE TRAIL
            </h2>
            <h3 className="text-4xl sm:text-5xl font-black text-white leading-tight" data-id="element-95">
              SABÉS ENTRENAR. <br className="hidden sm:block" data-id="element-96" />
              <span className="text-gray-500" data-id="element-97">
                PERO NECESITÁS UNA ESTRUCTURA LISTA.
              </span>
            </h3>
            <p className="mt-6 text-xl text-gray-400 leading-relaxed normal-case" data-id="element-98">
              El problema no es que no sepas dar clases. El problema es tener
              que crear todo desde cero cada semana: ejercicios,
              planificaciones, progresiones, seguridad, técnica, fuerza y
              organización del grupo.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-99">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-100">
              <div className="bg-brand-dark p-8 border border-brand-muted/20 hover:border-brand-volt/50 transition-colors group h-full" data-id="element-101">
                <div className="mb-6 bg-brand-surface w-16 h-16 flex items-center justify-center rounded-lg border border-brand-muted/10 group-hover:scale-110 transition-transform" data-id="element-102">
                  {pain.icon}
                </div>
                <h4 className="text-2xl font-bold text-white mb-3" data-id="element-103">
                  {pain.title}
                </h4>
                <p className="text-gray-400 leading-relaxed normal-case" data-id="element-104">
                  {pain.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}